export const showKabaddi = false;
export const showElection = true;
export const showBinary = false;
export const showChangePasswordBtn = true;
export const showCasinoControlLink = true;
export const lotusIndex = 1;
export const showAdminBannerLink = false;
export const showAdminBannerMax = 5;
export const showClubGames = {show:true, onlyInOfficeChnl: false};
export const SHOWSPLASHVIDEOSCREENMODALCONFIG = true;
export const SPLASHVIDEOURL = "https://www.youtube.com/embed/4pZbzUGTHM4?autoplay=1&controls=0&showinfo=0&disablekb=1&modestbranding=1&rel=0&start=0";
export const casinoList = [
{provider : "DRCROYAL", pnlLabel:"INDIAN_POKER/LIVE_CASINO_99", displayName : "Indian Poker/ Live Casino", mt:"INDIAN_POKER/LIVE_CASINO", bt:"ODDS", show : true},
{provider : "LOTUS", pnlLabel:"INDIAN_POKER_II_99", displayName : "Indian Poker II", mt:"INDIAN_POKER_II", bt:"ODDS", show : true},
{provider : "SUPERNOVA", pnlLabel:"INDIAN_POKER_II_99", displayName : "Indian Poker II", mt:"INDIAN_POKER_II", bt:"ODDS", show : false},
{provider : "PRAGMATIC", pnlLabel:"PRAGMATIC_99", displayName : "Pragmatic", mt:"PRAGMATIC", bt:"ODDS", show : false},
{provider : "EVOLUTION", pnlLabel:"EVOLUTION_99", displayName : "Evolution", mt:"EVOLUTION", bt:"ODDS", show : true},
{provider : "DRC", pnlLabel:"CASINO_99", displayName : "Casino II", mt:"CASINO", bt:"ODDS", show : false},
{provider : "VIVO", pnlLabel:"VIVO_99", displayName : "Vivo", mt:"VIVO", bt:"ODDS", show : true},
{provider : "WAC", pnlLabel:"WAC_99", displayName : "WAC", mt:"WAC", bt:"ODDS", show : false},
{provider : "BETGAMES", pnlLabel:"BETGAMES_99", displayName : "Betgames", mt:"BETGAMES", bt:"ODDS", show : true},
{provider : "DRCHUD", pnlLabel:"CASINO_III_99", displayName : "Casino III", mt:"CASINO_III", bt:"ODDS", show : true},
];
export const showRebateBonus = {show:false, onlyInOfficeChnl: false};
export const showNewUserPageServerSidePagination = false;
export const showBetHistoryCSVAll = false;
